import React, { Component } from "react";
import { Router, Route } from "react-router-dom";
import createBrowserHistory from "history/createBrowserHistory";

// import pages
import MainPage from "./mainpage/mainpage";
import Login from "./authentication/login";
import Register from "./authentication/register";
import ConfirmEmail from "./authentication/confirm_email";
import Dashboard from "./userpage/dashboard/dashboard";
import ProjectRegister from "./userpage/dashboard/registersteps/project_register_main";
import Reset from "./authentication/reset";
import ResetEnterPassword from "./authentication/reset_enter_password";
import PageNotFound from "./404";

// import style
import "./App.css";
const history = createBrowserHistory();

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: "userPage",
      loggedIn: false
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const homepage = process.env.PUBLIC_URL;
    return (
      <React.Fragment>
        <Route exact path={`${homepage}/`} component={MainPage} />
        <Route path={`${homepage}/login`} component={Login} />
        <Route path={`${homepage}/register`} component={Register} />
        {/* reset page start  */}
        {/* befora mail sent */}
        <Route path={`${homepage}/reset`} component={Reset} />
        <Route path={`${homepage}/user/confirm`} component={ConfirmEmail} />
        {/* after mail sent */}
        <Route
          path={`${homepage}/reset/enter_password/`}
          component={ResetEnterPassword}
        />
        {/* reset page end */}
        <Route
          path={`${homepage}/dashboard`}
          render={props => <Dashboard {...props} />}
        />
        <Route
          path={`${homepage}/project_register`}
          render={props => <ProjectRegister {...props} />}
        />
        {/* <Route path='*' component={PageNotFound} /> */}
      </React.Fragment>
    );
  }
}
